import styled, { css } from 'styled-components';
import {
    token,
    Text,
} from '@zillow/constellation';

export const StyledTourCardBadge = styled.div`
    position: absolute;
    z-index: 1;
    padding: 3px 7px;
    left: 0;
    top: 0;
    color: ${token('colors.white')};

    ${(props) => {
        switch (props.color) {
            case 'grey':
                return css`
                    background-color: ${token('colors.gray500')};
                `;
            case 'green':
                return css`
                    background-color: ${token('colors.green500')};
                `;
            default:
                return '';
        }
    }}
`;

export const StyledTourCardBadgeText = styled(Text)`
    font-weight: 600;
`;
